import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

function EditorWidget(props) {
    if (!props?.editor) return null;

    return (
        <div data-test-id="editor-wr" className={"widget widget-editor" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                <div data-test-id="editor-text" className={"editor col-12" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.editor) }}></div>
            </div>
        </div>
    )
}

EditorWidget.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    widget: PropTypes.string
}

export default EditorWidget;
